var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "featured-outfit-card-container" },
    [
      _c("featured-outfit-card", {
        attrs: {
          outfit: _vm.outfit,
          handleProductClk: _vm.handleItemClick,
          swapProductClk: function(product) {
            return _vm.$emit("swap-product", product, _vm.outfit)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "footer-buttons",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "footer-buttons" },
                  [
                    _c("share-outfit", { attrs: { outfit: _vm.outfit } }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "footer-button",
                        on: { click: _vm.shopItems }
                      },
                      [
                        _vm._v(
                          "\n                    Shop Items\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("purchase-outfit-button", {
                      attrs: {
                        classes: "footer-button footer-button--pink",
                        outfit: _vm.outfit
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.purchaseOutfit.apply(null, arguments)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f94c9848", { render: render, staticRenderFns: staticRenderFns })
  }
}